<template>
  <div id="app">
    <main class="empadronamiento">
      <section class="empadronamiento__intro">
        <div class="container">
          <notifications></notifications> 
          <div class="empadronamiento__intro__header">
            <img src="@/img/logo.png" alt />
          </div>
          <router-view></router-view>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import notifications from '@/components/common/Notifications'

export default {
  components: {
    notifications
  }
};
</script>
